import { kueskiAttribution, tracker } from '@kueski-dev/web-observability';
import { DATASOURCE, DOMAIN, LoggerFactory } from 'Services/Logger';
import { getVariable } from 'Utils/env';
import amplitude from './amplitude';

kueskiAttribution.providers = {
  amplitude,
};

tracker.init({
  apiKey: getVariable('OBSERVABILITY_API_KEY') || '',
  apiUrl: getVariable('OBSERVABILITY_API_URL') || '',
  appVersion: 'v1',
  defaultProduct: 'pay',
});

const logger = LoggerFactory.getLogger(DOMAIN.FRONT);
tracker.logger.addEventListener('log', ({
  level, message, method, ...data
}) => {
  logger[level](message, `${DATASOURCE.OBSERVABILITY}.tracker.${method}`, data);
});
